import classNames from 'classnames';
import React, { useState, useEffect, useRef } from 'react'
import './style.scss'
import { Link, NavLink } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
// import { FilterContext } from '../../../../providers/filterData-provider';
import { useFetch } from '../../../../hooks/index';

import { dpdSlice, actionsSlice, ptpSlice, trendSlice, amountSlice, filterSlice, lendFilterSlice } from '../../../../redux/reducers';

const SidebarComponents = () => {

    const [showDropdown, setShowDropDown] = useState(false);
    const [dropdownList, setDropDownList] = useState([]);
    const [collectFilterList, setCollectFilterList] = useState();
    const [dashboardList, setDashboardList] = useState([]);
    const dispatch = useDispatch();
    const selectedFilterValues = useSelector(state => state.filterValues.filterValues);
    const containerRef = useRef();
    const { api } = useFetch();
    // const { selectedLendFilterValues } = useContext(FilterContext);

    // console.log("selected lend filter values", selectedLendFilterValues);

    const baseUrl = process.env.REACT_APP_BASE_URL;

    const apiURL = `${baseUrl}/api/dashboard/collections/charts/actions`;
    const apiPtpURL = `${baseUrl}/api/dashboard/collections/charts/promises`;
    const apiTrendURL = `${baseUrl}/api/dashboard/collections/charts/collections-trend`;
    const apiAmountURL = `${baseUrl}/api/dashboard/collections/charts/payments`;
    const apiDpdURL = `${baseUrl}/api/dashboard/collections/charts/dpd-trend`;
    const apiFilterList = `${baseUrl}/api/filter/list/COLLECTION_DASHBOARD`;
    const lendFilterAPI = `${baseUrl}/api/filter/list/LEND_DASHBOARD`
    const dashboardListURL = `${baseUrl}/api/dashboard/list`;

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setShowDropDown(false);
        }
    };

    useEffect(() => {
        fetchDashboardList();
        filterDataApi();
        fetchData();
        fetchPtpData();
        fetchAmount();
        dpdData();
        // fetchAgents(filterData);
        fetchCollectionData();
        lendFilterData();
    }, [selectedFilterValues]);

    const fetchDashboardList = async () => {
        try {
            const response = await axios.get(dashboardListURL);
            setDashboardList(response?.data?.data);
        } catch (error) {
            console.log(error);
        }
    }

    const filterDataApi = async () => {
        try {
            const response = await axios.get(apiFilterList);
            setCollectFilterList(response?.data.data);
            dispatch(filterSlice?.actions?.filterReducer(response?.data?.data));
        } catch (error) {
            console.log(error);
        }
    }

    console.log("collect filter list =======>", collectFilterList);

    const lendFilterData = async () => {
        const { data } = await api(lendFilterAPI, 'GET');
        dispatch(lendFilterSlice?.actions?.lendFilterReducer(data));
    }

    const handleDropdown = () => {
        setShowDropDown(!showDropdown);
        const dashboardValues = dashboardList?.map(ele => ele.LABEL);
        setDropDownList(dashboardValues);
    }

    const fetchData = async () => {
        try {
            let payload = {
                filter: []
            };

            if (selectedFilterValues.HUB !== undefined && selectedFilterValues.HUB !== "") {

                payload.filter.push({
                    id: "ACCOUNTS.HUB",
                    value: selectedFilterValues.HUB,
                });
            }

            if (selectedFilterValues.AREA !== undefined && selectedFilterValues.AREA !== "") {

                payload.filter.push({
                    id: "ACCOUNTS.AREA",
                    value: selectedFilterValues.AREA,
                });
            }

            if (payload.filter.length > 0) {
                payload.filter.push({
                    id: "ACTION_HISTORY.ACTION_TAKEN_ON",
                    value: "day",
                    datatype: "DATE",
                });
            }

            const response = await axios.post(apiURL, payload);
            // setActionsData(response.data);
            dispatch(actionsSlice?.actions?.actionReducer(response?.data?.data));
        } catch (error) {
            console.error(error);
        }
    };

    const fetchPtpData = async () => {
        try {
            let payload = {
                filter: []
            };

            if (selectedFilterValues.HUB !== undefined && selectedFilterValues.HUB !== "") {
                payload.filter.push({
                    id: "ACCOUNTS.HUB",
                    value: selectedFilterValues.HUB,
                });
            }
            if (selectedFilterValues.AREA !== undefined && selectedFilterValues.AREA !== "") {
                payload.filter.push({
                    id: "ACCOUNTS.AREA",
                    value: selectedFilterValues.AREA,
                });
            }
            if (selectedFilterValues.REGION !== undefined && selectedFilterValues.REGION !== "") {
                payload.filter.push({
                    id: "ACCOUNTS.REGION",
                    value: selectedFilterValues.REGION,
                });
            }
            if (selectedFilterValues.from !== undefined && selectedFilterValues.to !== undefined &&
                selectedFilterValues.from !== "" && selectedFilterValues.to !== "") {
                payload.filter.push({
                    id: "ACTION_HISTORY.ACTION_TAKEN_ON",
                    datatype: "DATE",
                    value: {
                        from: selectedFilterValues.from,
                        to: selectedFilterValues.to,
                    },
                });
            }

            const response = await axios.post(apiPtpURL, payload);
            console.log(selectedFilterValues);
            console.log("=====> payload ptp", payload);
            // setActionsData(response.data);
            dispatch(ptpSlice?.actions?.ptpReducer(response?.data?.data));
        } catch (error) {
            console.error(error);
        }
    };

    const fetchAmount = async () => {
        try {
            let payload = {
                filter: []
            }
            if (selectedFilterValues.from !== undefined && selectedFilterValues.to !== undefined &&
                selectedFilterValues.from !== "" && selectedFilterValues.to !== "") {

                payload = {

                    filter: [
                        {
                            "id": "PAYMENTS.PAYMENT_DATE",
                            "datatype": "DATE",
                            "value": {
                                "from": `${selectedFilterValues.from}`,
                                "to": `${selectedFilterValues.to}`,
                            }
                        }
                    ]
                }
            }
            // setActionsData(response.data);
            const response = await axios.post(apiAmountURL, payload);
            dispatch(amountSlice?.actions?.amountReducer(response?.data?.data));
        } catch (error) {
            console.error(error);
        }
    }

    const dpdData = async () => {
        try {
            let payload = {
                filter: []
            };

            if (selectedFilterValues.from !== undefined && selectedFilterValues.to !== undefined &&
                selectedFilterValues.from !== "" && selectedFilterValues.to !== "") {
                payload = {
                    filter: [
                        {
                            id: "ACTION_HISTORY.ACTION_TAKEN_ON",
                            datatype: "DATE",
                            value: {
                                from: selectedFilterValues.from,
                                to: selectedFilterValues.to,
                            },
                        },
                    ],
                };
            }

            const response = await axios.post(apiDpdURL, payload);
            // console.log("dpd fetch call", response.data.data);
            dispatch(dpdSlice?.actions?.dpdReducer(response?.data?.data));
        } catch (error) {
            console.log(error);

        }
    };

    // const fetchAgents2 = async () => {
    //     try {
    //         let payload = {
    //             filter: []
    //         };

    //         if (selectedFilterValues.from !== undefined && selectedFilterValues.to !== undefined &&
    //             selectedFilterValues.from !== "" && selectedFilterValues.to !== "") {
    //             payload.filter.push(
    //                 {
    //                     id: "ACTION_HISTORY.ACTION_TAKEN_ON",
    //                     datatype: "DATE",
    //                     value: {
    //                         from: selectedFilterValues.from,
    //                         to: selectedFilterValues.to,
    //                     }
    //                 }
    //             );
    //         }

    //         if (selectedFilterValues.PRODUCT !== undefined && selectedFilterValues.PRODUCT !== "") {
    //             payload.filter.push(
    //                 {
    //                     id: "ACCOUNTS.PRODUCT_CODE",
    //                     value: selectedFilterValues.PRODUCT,
    //                 }
    //             )
    //         }

    //         const response = await axios.post(agentsUrl, payload);
    //         // console.log("======>", selectedFilterValues);
    //         // console.log("======> agent payload", payload);
    //         // setActionsData(response.data);
    //         dispatch(agentSlice?.actions?.agentReducer(response?.data?.data));
    //     } catch (error) {
    //         console.error(error);
    //     }
    // };
    // console.log(fetchAgents2);

    // const filterData = Object.keys(selectedFilterValues)?.map(key => {
    //     const filterConfig = selectedFilterValues?.find(ele => ele?.FILTER_ID === key);

    //     if (key === 'from' || key === 'to') {
    //         const dateFilterData = selectedFilterValues?.find(ele => ele?.DISPLAY_TYPE === 'DATE_PICKER');
    //         if (dateFilterData) {
    //             return {
    //                 id: `${dateFilterData.BASE_TABLE}.${dateFilterData.BASE_COLUMN}`,
    //                 datatype: 'DATE',
    //                 value: {
    //                     from: selectedFilterValues.from,
    //                     to: selectedFilterValues.to
    //                 }
    //             }
    //         }
    //     } else if (filterConfig) {
    //         const filterValues = Array.isArray(selectedFilterValues[key])
    //             ? selectedFilterValues[key] : [selectedFilterValues[key]];

    //         return filterValues?.map(value => ({
    //             id: `${filterConfig.BASE_TABLE}.${filterConfig.BASE_COLUMN}`,
    //             value
    //         }))
    //     }
    //     return null;
    // }).flat().filter(Boolean);

    // const fetchAgents = async (filterData = [], sort = []) => {
    //     try {
    //         //   const applicationDetailsAPI = `${process.env.REACT_APP_BASE_URL}/api/dashboard/lend/charts/applications-details`;
    //         const payload = {
    //             filter: filterData?.length > 0 ? filterData : [],
    //             sort: sort?.length > 0 ? sort : []
    //         }
    //         const response = await axios.post(agentsUrl, payload);
    //         dispatch(agentSlice?.actions?.agentReducer(response?.data?.data));
    //         //   setApplicationDetails(response?.data?.data);
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }
    // expectation : agents card should render with default values then on changing filter values,
    // agent should re render only if required selectedfiltervalues change.
    // console.log("=========> selected collect filter values", selectedFilterValues);

    const fetchCollectionData = async () => {
        try {

            let payload = {
                filter: []
            };

            if (selectedFilterValues.HUB !== undefined && selectedFilterValues.HUB !== "") {
                payload.filter.push(

                    {
                        id: "ACCOUNTS.HUB",
                        value: selectedFilterValues.HUB,
                    })
            }

            if (selectedFilterValues.AREA !== undefined && selectedFilterValues.AREA !== "") {
                payload.filter.push(
                    {
                        id: "ACCOUNTS.AREA",
                        value: selectedFilterValues.AREA,
                    }
                )
            }

            if (payload.filter.length > 0) {
                payload.filter.push({
                    id: "DEBT_DETAILS.DEBT_DATE",
                    datatype: "DATE",
                    value: "year",
                });
            }

            const response = await axios.post(apiTrendURL, payload);
            console.log(selectedFilterValues);
            console.log("==============> collection chart payload", payload);
            // setActionsData(response.data);
            dispatch(trendSlice?.actions?.trendReducer(response?.data?.data));
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className={classNames('sidebar-container')}>
            <div className='sidebar-container__header'>
                <Link to='/'>ANALYZE.EZEE</Link>
            </div>
            <div className='sidebar-container__pages' ref={containerRef}>
                <section>
                    <div onClick={handleDropdown} className={classNames('sidebar-container__pages__dashboard', { 'sidebar-container__pages__dashboard__clicked': showDropdown })}>
                        <p>Dashboards</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 8 10" fill="none">
                            <path d="M1.25 8.75L6.75 4.75L1.25 0.75" stroke="#D9D9D9" />
                        </svg>
                    </div>
                    {showDropdown && (
                        <ul className="sidebar-container__pages__dashboard__dropdown-list">
                            {dropdownList.map((item, index) => {
                                const urlParam = item?.split('.')[0];
                                return (
                                    <li key={index}>
                                        <NavLink to={`/dashboard/${urlParam}`}>{item}</NavLink>
                                    </li>)
                            })}
                        </ul>
                    )}
                </section>
                <section>
                    <div className='sidebar-container__pages__charts'>
                        <p>Charts</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 8 10" fill="none">
                            <path d="M1.25 8.75L6.75 4.75L1.25 0.75" stroke="#D9D9D9" />
                        </svg>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default SidebarComponents;
